import React, { useEffect, useState } from "react";
import "./index.scss";
import { API_URL } from "../../../../../constants/ApplicationUrl";

function ScoreCard({ data, adminScores, setAdminScores }) {


  useEffect(() => {
    setAdminScores({
      creditRatingScore: data?.ScoreCard?.score?.adminScore?.creditRatingScore,
      scalabilityScore: data?.ScoreCard?.score?.adminScore?.scalabilityScore,
    });
  }, [data]);

  const handleScoreChange = (field, value) => {
    setAdminScores((prev) => ({
      ...prev,
      [field]: Number(value),
    }));
  };

  return (
    <div className="entity-detail-inner table-card">
      <table>
        <thead>
          <tr>
            <th className="score-marks">
              <table>
                <tr>
                  <th>
                    Score card to evaluate applications of exemptions under
                    section 80-IAC <span>(Max Marks : 50)</span>
                  </th>
                  <th>SIH User Marks</th>
                  <th>Admin Response</th>
                  <th>Admin Marks</th>
                </tr>
              </table>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="tbody">
              <table>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6> Reconstruction (CA Certification)</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {data?.ScoreCard?.reconstruction?.caCertificate ? (
                            <a
                            href={`${API_URL()}${data?.ScoreCard?.reconstruction?.caCertificate?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                          ): (null)}
                          

                        </p>

                      </div>
                    </div>
                  </td>
                  <td></td>
                  <td>

                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6>Membership Number of the CA</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {data?.ScoreCard?.reconstruction?.caMembershipNumber}

                        </p>

                      </div>
                    </div>
                  </td>
                  <td></td>
                  <td> </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6>CREDIT Rating by any accredited agency</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {data?.ScoreCard?.creditRating ? (
                            <a
                            href={`${API_URL()}${data?.ScoreCard?.creditRating?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                          ): (null)}
                          


                        </p>

                      </div>
                    </div>
                  </td>
                  <td>{data?.ScoreCard?.score?.sihScore?.creditRatingScore}</td>
                  <td><select
                    className="form-select"
                    value={adminScores.creditRatingScore}
                    onChange={(e) => handleScoreChange("creditRatingScore", e.target.value)}
                  >
                    {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                    <option value="25">Yes</option>
                    <option value="0">No</option>
                  </select>
                  </td>
                  <td>{adminScores.creditRatingScore}</td>
                </tr>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6>Scalability (10% growth in revenue from one year to the next
                          or 25% growth over 2 years or over 33% growth over 3 years)</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {data?.ScoreCard?.scalability ? (
                            <a
                            href={`${API_URL()}${data?.ScoreCard?.scalability?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                          ): (null)}
                          

                        </p>

                      </div>
                    </div>
                  </td>
                  <td>{data?.ScoreCard?.score?.sihScore?.scalabilityScore}</td>
                  <td> <select
                    className="form-select"
                    value={adminScores.scalabilityScore}
                    onChange={(e) => handleScoreChange("scalabilityScore", e.target.value)}
                  >
                    {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                    <option value="25">Yes</option>
                    <option value="0">No</option>
                  </select>
                  </td>
                  <td>{adminScores.scalabilityScore}</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td className="tfoot">
              <table>

                <tr>
                  <td>
                    <h6>Sectional Marks Obtained <span>SIH User Marks </span></h6>
                  </td>
                  <td>
                    {data?.ScoreCard?.score?.sihScore?.totalGroupCredit}

                  </td>
                  <td>Admin Marks</td>
                  <td>
                    {adminScores?.scalabilityScore + adminScores?.creditRatingScore}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default ScoreCard;
